export default __webpack_public_path__ + "static/media/book_TheUmbralStorm.daa33fc6.jpeg";